import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faSearch,
  faSquarePlus,
} from "@fortawesome/free-solid-svg-icons";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PopupAHSF from "../PopupAHSF/index";
import loadConfig from "../../Services/Api/ApiServices";
import "./style.css";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SortingListDetailsOfResearchSubmittedForAwardLastFiveYears } from "../../Redux/Reducers/Submitter/DetailsOfResearchSubmittedForAwardLastFiveYears";
const TableAHSFDragDrop = (props) => {
  const [res, setRes] = useState([]);
  const [stateSort, setStateSort] = useState();
  const [filterData, setFilterData] = useState([]);
  const [jsonData, setJsonData] = useState({});
  const [jsonLoding, setJsonLoding] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [openPopupState, setOpenPopupState] = useState(props.openPopupState);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [refreshSortingTable, setefreshSortingTable] = useState(false);
  const dispatch = useDispatch();
  // Pagination states
  const [stebPagination, setStebPagination] = useState(0);
  const [endpagination, setEndPagination] = useState(5);
  const [hover, setHover] = useState(false);

  const itemsPerPage = props.itemsPerPage || 5; // عدد الصفوف الافتراضي للصفحة

  useEffect(() => {
    const getJson = async () => {
      const json = await loadConfig();
      setJsonData(json);
      setJsonLoding(true);
    };
    getJson();
  }, []);

  useEffect(() => {
    if (jsonData.domainUrl && props.URL) {
      axios
        .post(`${jsonData.domainUrl}/${props.URL}`, props.UrlBody, {
          headers: {
            Authorization: `${sessionStorage.getItem("AccessToken")}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setRes(response.data.result);
          setFilterData(response.data.result);
        })
        .catch(console.error);
    }
  }, [jsonLoding, props.URL, props.UrlBody, jsonData]);

  const arabicNormChar = {
    ك: "ک",
    ى: "ی",
    ي: "ی",
    أ: "ا",
    إ: "ا",
    آ: "ا",
    ة: "ه",
    " ": "",
  };
  const simplifyArabic = (value) =>
    value
      .replace(/[^\u0000-\u007E]/g, (c) => arabicNormChar[c] ?? c)
      .normalize("NFKD")
      .toLowerCase();

  const handelSearch = (e) => {
    const searchResult = filterData.filter((opject) =>
      simplifyArabic(Object.values(opject).join("")).includes(
        simplifyArabic(e.target.value)
      )
    );
    setRes(searchResult);
    setSearchValue(e.target.value);
    // Reset pagination after search
    setStebPagination(0);
    setEndPagination(itemsPerPage);
  };

  const handleCheckboxChange = (option, e) => {
    if (e.target.checked) {
      setSelectedOptions((prev) => [
        ...prev,
        { key: option.keyValueName, value: option.value },
      ]);
    } else {
      setSelectedOptions((prev) =>
        prev.filter(
          (selected) =>
            selected.key !== option.keyValueName ||
            selected.value !== option.value
        )
      );
    }
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  // Filter based on dropdown options
  let filteredData = Object.entries(
    selectedOptions.reduce((acc, { key, value }) => {
      if (!acc[key]) acc[key] = [];
      acc[key].push(value);
      return acc;
    }, {})
  ).reduce(
    (data, [key, values]) =>
      data.filter((option) => values.includes(option[key])),
    res
  );

  const groupDataByKeys = (data, mergeColumns) => {
    const groupsMap = new Map();
    const groupsOrder = [];
    data.forEach((row) => {
      const key = mergeColumns.map((col) => row[col]).join("|");
      if (!groupsMap.has(key)) {
        groupsMap.set(key, []);
        groupsOrder.push(key);
      }
      groupsMap.get(key).push(row);
    });
    return groupsOrder.map((key) => groupsMap.get(key));
  };

  function DraggableRow({ row, rowIndex, groupLength, children }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({
        id: row.id || rowIndex,
      });
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: "grab",
    };
    return (
      <tr
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        className={`rtrtrt group-${rowIndex} ${
          groupLength > 1 ? "merged-row-highlight" : ""
        }`}
      >
        {children}
      </tr>
    );
  }
  const sendNewOrderToBackend = async (newData) => {
    if (props.tableBtn) {
      const result = await dispatch(
        SortingListDetailsOfResearchSubmittedForAwardLastFiveYears(newData)
      );
      if (result.payload.code == 200) {
        setefreshSortingTable(!refreshSortingTable);
      }
    }
  };
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      // إعادة ترتيب البيانات محليًا
      const oldIndex = filteredData.findIndex(
        (r, i) => r.id === active.id || i === active.id
      );
      const newIndex = filteredData.findIndex(
        (r, i) => r.id === over.id || i === over.id
      );
      const newData = arrayMove(filteredData, oldIndex, newIndex);

      // تحديث الحالة محليًا
      setRes(newData);

      // تنفيذ Function للـ Backend
      sendNewOrderToBackend(newData);
    }
  };

  // البيانات المعروضة في الصفحة الحالية
  const displayedData = filteredData;
  //changes
  // .slice(stebPagination, endpagination);
  const displayedDataSlice = filteredData.slice(stebPagination, endpagination);
  const numberWithCommas = (x) => {
    if (x != null) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };
  return (
    <div className="tableContainer" id={props.tableId}>
      <div className="headTable">
        <div className="CenterSection">
          {/* {props.tableBtn && (
            <button
              onClick={() =>
                props.AddFunctionButtonPopup
                  ? props.AddFunctionButtonPopupFunction()
                  : setOpenPopupState(true)
              }
              className="tableBtn "
              title="اضافة"
            >
              <FontAwesomeIcon
                icon={faSquarePlus}
                style={{ color: "#f9a825" }}
              />
            </button>
          )} */}
          <h4 className="titelTable">
            {props.lang !== "en" ? props.titelTable : props.titelTableEN}
          </h4>
        </div>
        <div className="rightSection">
          {props.DropdownFiltration && (
            <div className="dropdown" ref={dropdownRef}>
              <button className="dropdown-toggle" onClick={toggleDropdown}>
                {props.lang !== "en" ? "🔽 اختر الخيارات " : "select 🔽"}
              </button>
              {isOpen && (
                <div className="dropdown-content">
                  {props.DropdownArrayFiltration.map((option, ind) => (
                    <label key={ind}>
                      <input
                        type="checkbox"
                        checked={selectedOptions.some(
                          (s) => s.value === option.value
                        )}
                        onChange={(e) => handleCheckboxChange(option, e)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              )}
            </div>
          )}
          {props.search && (
            <>
              <div className="input-wrapper">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <input
                  id="searchInput"
                  // placeholder="بحث"
                  // placeholder="🔍 بحث"
                  placeholder={props.lang !== "en" ? "ابحث هنا" : "search"}
                  onChange={(e) => {
                    handelSearch(e);
                    setSearchValue(e.target.value);
                  }}
                  disabled={false}
                />{" "}
                {/* <label id="searchIcon">
                               <BiSearch />
                             </label> */}
              </div>
            </>
          )}
        </div>
      </div>

      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          items={
            jsonData.pagination
              ? displayedDataSlice.map((r, i) => r.id || i)
              : displayedData.map((r, i) => r.id || i)
          }
          strategy={verticalListSortingStrategy}
        >
          <div className="bodyTable">
            {props.TableComponent ? (
              <div className="TableComponent">{props.TableComponent}</div>
            ) : (
              ""
            )}
            <table>
              <thead className="head_table" dir="rtl">
                <tr>
                  {props.arrayButton && (
                    <th
                      style={{
                        backgroundColor: props.tableBtn
                          ? hover
                            ? "#62bae9" // hover color when tableBtn = true
                            : "#f9a825" // normal color when tableBtn = true
                          : "#def0f08f", // when tableBtn = false
                        transition: "transform 0.2s ease-in-out",
                      }}
                      onMouseEnter={() => props.tableBtn && setHover(true)}
                      onMouseLeave={() => props.tableBtn && setHover(false)}
                    >
                      {" "}
                      {props.tableBtn ? (
                        <>
                          <button
                            onClick={() => {
                              if (!props.AddFunctionButtonPopup) {
                                setOpenPopupState(true);
                              } else {
                                props.AddFunctionButtonPopupFunction();
                              }
                            }}
                            className="tableBtn"
                            title={props.lang === "ar" ? "إضافة" : "Add"}
                          >
                            <FontAwesomeIcon
                              icon={faSquarePlus}
                              // style={{ color: "#0095DA" }}
                              style={{ color: "#fff" }}
                            />
                            <span
                              //  style={{ color: "#192569f7" }}
                              style={{ color: "#fff" }}
                            >
                              {props.lang === "ar" ? "إضافة" : "Add"}
                            </span>
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                    </th>
                  )}
                  {props.accessor.map((ele, ind) => {
                    if (ele.ShowStatus) {
                      return props.sort ? (
                        props.arrayNameSort.includes(ele.NmaeColumn) ? (
                          <th>
                            {ele}{" "}
                            <label>
                              {stateSort === "Descending" ? (
                                // <TbSortAscending />
                                <></>
                              ) : (
                                // <PiSortAscendingFill />
                                <></>
                              )}
                            </label>
                          </th>
                        ) : (
                          <th>
                            {props.lang !== "en"
                              ? ele.NmaeColumn
                              : ele.NmaeColumnEN}
                          </th>
                        )
                      ) : (
                        <th>
                          {props.lang == "ar"
                            ? ele.NmaeColumn
                            : ele.NmaeColumnEN}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {(props.mergeColumns
                  ? groupDataByKeys(
                      jsonData.pagination ? displayedDataSlice : displayedData,
                      props.mergeColumns
                    ).flatMap((group) => group)
                  : jsonData.pagination
                  ? displayedDataSlice
                  : displayedData
                ).map((row, idx) => (
                  <DraggableRow
                    key={row.id || idx}
                    row={row}
                    rowIndex={idx}
                    groupLength={1}
                  >
                    <td className="actionButton" style={{ cursor: "grab" }}>
                      {props.dragDropIcon ? (
                        <FontAwesomeIcon icon={faBars} />
                      ) : (
                        ""
                      )}
                      &nbsp;
                      {props.arrayButton &&
                        props.arrayButton.map((ele, ind) => {
                          if (props.RequestsManagerValue) {
                            if (ele.caneEditValue) {
                              if (row.canEdit && ele.ShowStatus) {
                                return (
                                  <>
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                      title={ele.title}
                                    >
                                      {ele.content}{" "}
                                    </button>
                                  </>
                                );
                              } else {
                                return <></>;
                              }
                            }

                            if (props.AllValueAction && ele.ShowStatus) {
                              return (
                                <>
                                  <button
                                    value={JSON.stringify(row)}
                                    onClick={ele.Click}
                                    id={ele.id}
                                    onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                    className={`buttonActionColumn ${ele.className}`}
                                    title={ele.title}
                                  >
                                    {ele.content}{" "}
                                  </button>
                                </>
                              );
                            }
                          } else if (ele.caneEditValue) {
                            if (row.canEdit && ele.ShowStatus) {
                              return (
                                <>
                                  <button
                                    value={row}
                                    onClick={ele.Click}
                                    onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                    id={ele.id}
                                    className={`buttonActionColumn ${ele.className}`}
                                    title={ele.title}
                                  >
                                    {ele.content}{" "}
                                  </button>
                                </>
                              );
                            } else {
                              return <></>;
                            }
                          } else if (ele.byStatusShowOrHide) {
                          } else if (
                            ele.InitialScreeningAssessment &&
                            ele.ShowStatus
                          ) {
                            return (
                              <>
                                <button
                                  value={JSON.stringify(row)}
                                  onClick={ele.Click}
                                  id={ele.id}
                                  onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                  className={`buttonActionColumn ${ele.className}`}
                                  title={ele.title}
                                >
                                  {ele.content}{" "}
                                </button>
                              </>
                            );
                          } else if (ele.ShowHideByCanEdit) {
                            if (ele.ShowHideByUser) {
                              if (row.canEdit) {
                                return (
                                  <>
                                    <button
                                      value={JSON.stringify(row)}
                                      onClick={ele.Click}
                                      onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                      title={ele.title}
                                    >
                                      {ele.content}{" "}
                                    </button>
                                  </>
                                );
                              }
                            } else {
                              return <></>;
                            }
                          } else if (ele.InitialScreeningAssessment_) {
                          } else if (ele.ShowStatus) {
                            if (
                              ele.ForSpecificLineStatus === true &&
                              row[ele.ForSpecificLineName] ==
                                ele.ForSpecificLineId
                            ) {
                              return (
                                <button
                                  value={JSON.stringify(row)}
                                  onClick={ele.Click}
                                  title={ele.title}
                                  onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                  id={ele.id}
                                  className={`buttonActionColumn ${ele.className}`}
                                >
                                  {ele.content}{" "}
                                </button>
                              );
                            } else if (
                              row[ele.ForSpecificLineName] ==
                                "00000000-0000-0000-0000-000000000000" &&
                              ele.id == "editBtn"
                            ) {
                              return <></>;
                            } else if (props.lastButton && ele.ShowLast) {
                              if (
                                // props.lengthReportsStages ==
                                filteredData[filteredData.length - 1] == row
                              ) {
                                return (
                                  <button
                                    value={JSON.stringify(row)}
                                    onClick={ele.Click}
                                    id={ele.id}
                                    onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                    className={`buttonActionColumn ${ele.className}`}
                                    title={ele.title}
                                  >
                                    {ele.content}{" "}
                                  </button>
                                );
                              }
                            } else if (!ele.ForSpecificLineStatus) {
                              if (props.KeyCondition) {
                                if (
                                  row[props.KeyCondition] ==
                                  props.modelCondition[props.KeyCondition]
                                ) {
                                  if (props.btnNotToShow != ele.id) {
                                    // console.log("resssssss");
                                    return (
                                      <button
                                        value={JSON.stringify(row)}
                                        onClick={ele.Click}
                                        id={ele.id}
                                        title={ele.title}
                                        onPointerDown={(e) =>
                                          e.stopPropagation()
                                        } // هذا يمنع الـ drag عند الضغط على الزر
                                        className={`buttonActionColumn ${ele.className}`}
                                      >
                                        {ele.content}{" "}
                                      </button>
                                    );
                                  }
                                } else {
                                  return (
                                    <button
                                      value={JSON.stringify(row)}
                                      title={ele.title}
                                      onClick={ele.Click}
                                      onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                      id={ele.id}
                                      className={`buttonActionColumn ${ele.className}`}
                                    >
                                      {ele.content}{" "}
                                    </button>
                                  );
                                }
                              }
                              if (ele?.keyNameTarget) {
                                return (
                                  <button
                                    value={row[ele?.keyNameTarget]}
                                    onClick={ele.Click}
                                    id={ele.id}
                                    onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                    className={`buttonActionColumn ${ele.className}`}
                                    title={ele.title}
                                  >
                                    {ele.content}{" "}
                                  </button>
                                );
                                //هذه الجزئية للتحكم في اظهار btn على حسب قيمة معينة
                              } else if (ele.ShowHideBtn) {
                                let isVisible = false;

                                if (Array.isArray(ele.ShowHideBtn)) {
                                  // لازم كل الشروط تتحقق
                                  isVisible = ele.ShowHideBtn.every(
                                    (condition) => {
                                      return (
                                        condition.statusToWork === true &&
                                        row[condition?.KeyName] ==
                                          condition.Value
                                      );
                                    }
                                  );
                                } else {
                                  // حالة شرط واحد فقط
                                  isVisible =
                                    ele.ShowHideBtn.statusToWork === true &&
                                    row[ele.ShowHideBtn?.KeyName] ==
                                      ele.ShowHideBtn.Value;
                                }

                                if (isVisible) {
                                  return (
                                    <button
                                      value={JSON.stringify(row)}
                                      title={ele.title}
                                      onClick={ele.Click}
                                      id={ele.id}
                                      onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                      className={`buttonActionColumn ${ele.className}`}
                                    >
                                      {ele.content}{" "}
                                      {/* <motion.div
                                        whileHover={{
                                          scale: 1.3,
                                          rotate: -20,
                                          color: "red",
                                        }}
                                        whileTap={{ scale: 0.9 }}
                                        transition={{
                                          type: "spring",
                                          stiffness: 300,
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTrash} />
                                      </motion.div> */}
                                    </button>
                                  );
                                } else {
                                  return <></>;
                                }
                              } else {
                                return (
                                  <button
                                    value={JSON.stringify(row)}
                                    title={ele.title}
                                    onClick={ele.Click}
                                    onPointerDown={(e) => e.stopPropagation()} // هذا يمنع الـ drag عند الضغط على الزر
                                    id={ele.id}
                                    className={`buttonActionColumn ${ele.className}`}
                                  >
                                    {ele.content}{" "}
                                  </button>
                                );
                              }
                            }
                          }
                        })}
                    </td>
                    {props.accessor.map((col, colIndex) => {
                      if (!col.ShowStatus) return null;
                      // const isGroupFirst = rowIndex === 0;
                      // const isGroupLast = rowIndex === groupLength - 1;
                      const cellValue = row[col?.KeyName];
                      const isMergedCol = props.mergeColumns?.includes(
                        col?.KeyName
                      );
                      // if (isMergedCol && rowIndex > 0) return null; // تجاهل الصفوف المكررة
                      // const rowSpan = isMergedCol ? groupLength : 1;

                      const renderContent = () => {
                        if (col.comma) return numberWithCommas(cellValue);
                        if (
                          col?.KeyName === props.dateKey ||
                          col?.KeyName === props.dateKey2
                        )
                          return moment(cellValue).format(props.dateformat);
                        if (col.typeColumn === "file" && cellValue !== null) {
                          const fileStore = props.fileStoreName;
                          return (
                            <Link
                              target="_blank"
                              className="AttachmentTable"
                              to={`${jsonData.domainUrl}/${fileStore}/${cellValue}`}
                            >
                              <button className="open-file">
                                <span className="file-wrapper">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 71 67"
                                  >
                                    <path
                                      strokeWidth="5"
                                      stroke="black"
                                      d="M41.7322 11.7678L42.4645 12.5H43.5H68.5V64.5H2.5V2.5H32.4645L41.7322 11.7678Z"
                                    />
                                  </svg>
                                  <span className="file-front"></span>
                                </span>
                              </button>
                            </Link>
                          );
                        }
                        if (cellValue === true) return props.trueText;
                        if (cellValue === false) return props.falseText;
                        return cellValue;
                      };

                      return (
                        <td
                          key={colIndex}
                          // rowSpan={rowSpan}
                          // className={isMergedCol ? "merged" : ""}

                          // className={
                          //   isMergedCol ??
                          //   `merged ${isGroupFirst ? "first-in-group" : ""} ${
                          //     isGroupLast ? "last-in-group" : ""
                          //   }`
                          // }
                        >
                          {isMergedCol ? (
                            <div className="merged-cell">{renderContent()}</div>
                          ) : (
                            renderContent()
                          )}
                        </td>
                      );
                    })}
                  </DraggableRow>
                ))}
              </tbody>
            </table>
          </div>
        </SortableContext>
      </DndContext>

      {/* Pagination القديم مع الاحتفاظ بالتصميم */}
      {jsonData.pagination ? (
        <div className="pagination">
          <div className="slectShowRow">
            {/* changes */}
            {props.selectRowNumber && (
              <select
                onChange={(e) => {
                  const val = parseInt(e.target.value);
                  setEndPagination(val);
                  setStebPagination(0);
                }}
              >
                {[5, 10, 15, 20, 25, 30, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            )}
            {props.selectRpwNumber && <label>عدد الصفوف الظاهرة</label>}
          </div>

          <div className="rightSection">
            <button
              onClick={() => {
                if (stebPagination >= itemsPerPage) {
                  setStebPagination(stebPagination - itemsPerPage);
                  setEndPagination(endpagination - itemsPerPage);
                }
              }}
            >
              {/* changes */}
              <AiOutlineDoubleRight />
            </button>
            {/* changes */}
            <label>
              {props.lang !== "en"
                ? `صفحة ${Math.floor(
                    endpagination / itemsPerPage
                  )} - من ${Math.ceil(filteredData.length / itemsPerPage)} صفحة`
                : `Page ${Math.floor(
                    endpagination / itemsPerPage
                  )} - from ${Math.ceil(filteredData.length / itemsPerPage)}`}
            </label>

            <button
              onClick={() => {
                if (endpagination < filteredData.length) {
                  setStebPagination(stebPagination + itemsPerPage);
                  setEndPagination(endpagination + itemsPerPage);
                }
              }}
            >
              {/* changes */}
              <AiOutlineDoubleLeft />
            </button>
          </div>
          <div className="leftSection"></div>
        </div>
      ) : (
        //className="pagination"
        <div className="">
          <div className="slectShowRow"></div>

          {/* <div className="rightSection">
            <button
              onClick={() => {
                if (stebPagination >= itemsPerPage) {
                  setStebPagination(stebPagination - itemsPerPage);
                  setEndPagination(endpagination - itemsPerPage);
                }
              }}
            ></button>

            <button
              onClick={() => {
                if (endpagination < filteredData.length) {
                  setStebPagination(stebPagination + itemsPerPage);
                  setEndPagination(endpagination + itemsPerPage);
                }
              }}
            ></button>
          </div> */}
          <div className="leftSection"></div>
        </div>
      )}
      {/* {jsonData.Nopagination ? (
        <div className="pagination">
          <div className="slectShowRow"></div>

          <div className="rightSection">
            <button
              onClick={() => {
                if (stebPagination >= itemsPerPage) {
                  setStebPagination(stebPagination - itemsPerPage);
                  setEndPagination(endpagination - itemsPerPage);
                }
              }}
            ></button>

            <button
              onClick={() => {
                if (endpagination < filteredData.length) {
                  setStebPagination(stebPagination + itemsPerPage);
                  setEndPagination(endpagination + itemsPerPage);
                }
              }}
            ></button>
          </div>
          <div className="leftSection"></div>
        </div>
      ) : null} */}

      <PopupAHSF
        isPopupOpenStatus={openPopupState}
        isPopupOpenFunction={() => setOpenPopupState(false)}
        lang={props.lang}
        title={props.PopupOPjectData.title}
        titleEN={props.PopupOPjectData.titleEN}
        componentBody={props.PopupOPjectData.componentBody}
        maxWidth={props.PopupOPjectData.maxWidth}
        maxHeight={props.PopupOPjectData.maxHeight}
      />
      {props.popUpBody}
    </div>
  );
};

export default TableAHSFDragDrop;
